import { api } from "./api";

let cache = null;
let promise = null;

export function getPublicConfig() {
  if (cache) return Promise.resolve(cache);
  if (!promise) {
    promise = api.get("/config/public").then(({ data }) => { cache = data; return data; }).catch(() => { promise = null; return null; });
  }
  return promise;
}
